<template>
  <form action="" method="post">
    <h4 class="mbs">Nouvelles et e-mails d'annonce</h4>
    <span>{{ email }}</span>
    <div class="row mtm">
      <div class="column small-12">
        <label>
          <input
            v-model="productOfferAndPromotion"
            type="checkbox"
            name="offersAndPromotions"
            class="input-type--checkbox"
          />
          <span>
            <strong class="text-black"
              >Offres et promotions de produits</strong
            >
          </span>
        </label>
      </div>
      <div class="column small-12">
        <p class="text-medium mll">
          Recevoir des offres adaptées DesignCrowd tous les mois !
        </p>
      </div>
    </div>
    <div class="row">
      <div class="column small-12">
        <label class="mtm">
          <input
            v-model="newsletter"
            type="checkbox"
            name="newsletter"
            class="input-type--checkbox"
          />
          <span>
            <strong class="text-black">Newsletter</strong>
          </span>
        </label>
      </div>
      <div class="column small-12">
        <p class="text-medium mll">
          {{ unPrettierNuggets.newsletterBlurb }}
        </p>
      </div>
    </div>
    <hr />
    <h4 class="mbm">E-mails spécifiques au projet</h4>
    <div class="row">
      <div class="column small-12">
        <label>
          <input
            v-model="generalProjectAlert"
            type="checkbox"
            name="newsletter"
            class="input-type--checkbox"
          />
          <span>
            <strong class="text-black">
              Alertes/notifications générales du projet
            </strong>
          </span>
        </label>
      </div>
      <div class="column small-12">
        <p class="text-medium mll">
          {{ unPrettierNuggets.generalProjectAlertBlurb }}
        </p>
      </div>
    </div>
    <div class="row">
      <div class="column small-12">
        <label class="mtm">
          <input
            v-model="newDesignNotification"
            type="checkbox"
            name="newsletter"
            class="input-type--checkbox"
          />
          <span>
            <strong class="text-black">Nouvelle notification de design</strong>
          </span>
        </label>
      </div>
      <div class="column small-12">
        <p class="text-medium mll">
          {{ unPrettierNuggets.newDesignNotificationBlurb }}
        </p>
      </div>
    </div>
    <div class="row">
      <div class="column small-12">
        <label class="mtm">
          <input
            v-model="dailySummary"
            type="checkbox"
            name="newsletter"
            class="input-type--checkbox"
          />
          <span>
            <strong class="text-black">E-mail récapitulatif quotidien</strong>
          </span>
        </label>
      </div>
      <div class="column small-12">
        <p class="text-medium mll">
          {{ unPrettierNuggets.dailySummaryBlurb }}
        </p>
      </div>
    </div>
    <div class="row">
      <div class="column small-12">
        <label class="mtm">
          <input
            v-model="inviteNotification"
            type="checkbox"
            name="newsletter"
            class="input-type--checkbox"
          />
          <span>
            <strong class="text-black">Notification d'invitation</strong>
          </span>
        </label>
      </div>
      <div class="column small-12">
        <p class="text-medium mll">
          {{ unPrettierNuggets.inviteNotificationBlurb }}
        </p>
      </div>
    </div>
    <div class="row">
      <div class="column text-center">
        <hr class="horizontal-rule horizontal-rule--form-frame-small mvm" />
        <button class="button mbn" @click="onSubmitUpdateSubscriptionsForm">
          Préférences de mise à jour
        </button>
      </div>
    </div>
  </form>
</template>

<script>
export default {
  props: {
    email: {
      type: String,
      default: undefined,
    },
    productOfferAndPromotionEnabled: {
      type: Boolean,
      default: false,
    },
    newsletterEnabled: {
      type: Boolean,
      default: false,
    },
    generalProjectAlertEnabled: {
      type: Boolean,
      default: false,
    },
    newDesignNotificationEnabled: {
      type: Boolean,
      default: false,
    },
    dailySummaryEnabled: {
      type: Boolean,
      default: false,
    },
    inviteNotificationEnabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      productOfferAndPromotion: this.productOfferAndPromotionEnabled,
      newsletter: this.newsletterEnabled,
      generalProjectAlert: this.generalProjectAlertEnabled,
      newDesignNotification: this.newDesignNotificationEnabled,
      dailySummary: this.dailySummaryEnabled,
      inviteNotification: this.inviteNotificationEnabled,
      unPrettierNuggets: {
        newsletterBlurb: `Envoyez-moi la newsletter mensuelle (ou à peu près) organisée à la main, remplie d'articles techniques, commerciaux et de design, de mises à jour de produits, de tutoriels, de profils et de nouvelles de la communauté`,
        inviteNotificationBlurb: `Envoyez-moi une notification lorsque les designers acceptent/rejettent les invitations`,
        generalProjectAlertBlurb: `Envoyez-moi des e-mails liés à mes projets et concours (tels que des paiements et des e-mails sur l'état du projet)`,
        newDesignNotificationBlurb: `Envoyez-moi une notification chaque fois qu'un nouveau design est soumis à mon projet`,
        dailySummaryBlurb: `Envoyez-moi un résumé quotidien des nouveaux designs et des activités associées à mes projets en direct`,
      }
    };
  },
  methods: {
    onSubmitUpdateSubscriptionsForm(e) {
      e.preventDefault();
      this.$emit('update-subscription', {
        productOfferAndPromotionEnabled: this.productOfferAndPromotion,
        newsletterEnabled: this.newsletter,
        generalProjectAlertEnabled: this.generalProjectAlert,
        newDesignNotificationEnabled: this.newDesignNotification,
        dailySummaryEnabled: this.dailySummary,
        inviteNotificationEnabled: this.inviteNotification,
      });
    },
  },
};
</script>
